angular.module('bmsApp.trugreen.job').controller('TGCloseJobCtrl',
	function ($state,
			  TGSalesTypeSvc,
			  TGVisitSvc,
			  TGJobSvc,
			  TGTreatmentSvc,
			  $ngBootbox,
			  PaymentTypeSvc,
			  TGTreatmentProductSvc,
			  TGChemicalRecordSvc,
			  $q,
			  notify,
			  $mdDialog,
			  TaxHelperSvc,
			  $scope,
				RecentPaymentSvc) {


		$scope.formValidator = {};
		$scope.formvalidatorconfig = {};

		function init() {
			var promises = {
				visit: TGVisitSvc.read($state.params.visitId),
				job: TGJobSvc.read($state.params.jobId),
				salesTypes: TGSalesTypeSvc.options(),
				paymentTypes: PaymentTypeSvc.options(),
				tax: TaxHelperSvc.setVatRate()
			};

			$q.all(promises).then(function (responses) {
				self.options.salesTypes = responses.salesTypes.data.options;
				self.options.paymentTypes = responses.paymentTypes.data.options;
				self.visit = angular.merge({
					discount_price: 0,
					discount_price_vat: 0,
					discount_price_gross: 0,
				}, responses.visit.data.tg_visit);
				self.job = responses.job.data.tg_job;
				self.visit.discount_price = 0; // initialise to zero
				if (self.visit.closed && self.visit.customer_payment) {
					self.payment_collected = true;
				}

				// Set all additional treatments to completed
				angular.forEach(self.visit.treatments, function(visitTreatment) {
					if (visitTreatment.treatment.additional_treatment) {
						angular.extend(visitTreatment, {
							completed: true
						});
					}
				});

				if (angular.isString(self.visit.start_time)) {
					self.visit.start_time = moment(self.visit.start_time, "HH:mm");
				}
				if (angular.isString(self.visit.end_time)) {
					self.visit.end_time = moment(self.visit.end_time, "HH:mm");
				}

				// VAT
				if (self.visit.additional_cost === null) {
					self.visit.additional_cost = {};
				}
				self.visit.additional_cost.vat_rate = Number(responses.tax);

				// Additional cost
				self.canAddAdditionalCost = (self.visit.job.invoice_method === 'each_visit');

				isPreinvoiced();
				generateInvoiceSummary();

				$scope.$emit('closeJobUpdated', {
					job: self.job,
					visit: self.visit,
					preinvoiced: self.visitPreinvoiced
				});
				self.loading = false;
			});
		}

		function isPreinvoiced() {
			self.visitPreinvoiced = self.visit.preinvoiced;
		}

		function treatmentInactivePressed(treatment) {
			if (treatment.inactive) {
				treatment.completed = true;
			}
			generateInvoiceSummary();
		}

		function onAdditionalCostNetChanged() {
			let additionalCost = self.visit.additional_cost;
			additionalCost.vat = TaxHelperSvc.vatFromNet(additionalCost.net);
			additionalCost.gross = TaxHelperSvc.grossFromNet(additionalCost.net);
			generateInvoiceSummary();
		}

		function onAdditionalCostGrossChanged() {
			let additionalCost = self.visit.additional_cost;
			additionalCost.net = TaxHelperSvc.netFromGross(additionalCost.gross);
			additionalCost.vat = TaxHelperSvc.vatFromGross(additionalCost.gross);
			generateInvoiceSummary();
		}

		function editProduct(treatment, product) {
			if (angular.isObject(product.chemical_record)) {
				$ngBootbox.confirm('There is a chemical application record associated with this product, this will automatically be removed if you edit the product. Continue?')
					.then(function () {
						showEditProductModal(treatment, product);
					});
			}
			else {
				showEditProductModal(treatment, product);
			}
		}

		function showEditProductModal(treatment, product) {
			TGTreatmentProductSvc.showTreatmentProductModal(treatment, product).then(function (result) {
				angular.extend(product, result.product);
			});
		}

		function chemicalRecord(treatment, product) {
			TGChemicalRecordSvc.showChemicalRecordModal(treatment, product).then(function (result) {
				angular.extend(product, result.product);
			});
		}

		function editTreatment(treatment) {
			TGTreatmentSvc.showJobTreatmentModal(self.job, treatment.treatment).then(function (result) {
				angular.extend(treatment.treatment, result.jobTreatment);
				generateInvoiceSummary();
			});
		}

		function addTreatment() {
			TGTreatmentSvc.showJobTreatmentModal(self.job).then(function (result) {
				var visitTreatment = {
					visit_id: self.visit.id,
					treatment_id: null,
					completed: true,
					inactive: false,
					treatment_number: 1,
					work_duration_in_mins: result.jobTreatment.treatment_time_in_mins,
					treatment: result.jobTreatment
				};

				visitTreatment.treatment.additional_treatment = true;
				visitTreatment.isNew = true;
				self.visit.treatments.push(visitTreatment);
				generateInvoiceSummary();
			});
		}

		function deleteTreatment(treatment) {
			$ngBootbox.confirm('Are you sure you want to remove this treatment?').then(function () {
				if (treatment.isNew) {
					self.visit.treatments.splice(self.visit.treatments.indexOf(treatment), 1);
				}
				else {
					angular.extend(treatment, {
						delete: true
					});
				}
				generateInvoiceSummary();
			});

		}

		function timeUpdated() {
			if (moment.isMoment(self.visit.start_time) && moment.isMoment(self.visit.end_time)) {
				var difference = self.visit.end_time.diff(self.visit.start_time, 'minutes');
				self.visit.total_visit_minutes = (difference > 0) ? difference : '-';
			}
		}

		function addCustomerPayment() {
			if (!self.visit.closed) {
				angular.extend(self.visit, {
					customer_payment: {
						payment_type: null,
						received_amount: 0,
						cheque_no: ''
					}
				});
			}
		}

		function removeCustomerPayment() {
			if (!self.visit.closed) {
				delete self.visit.customer_payment;
			}
		}

		function applyInvoiceDiscount(ev) {
			var confirm = $mdDialog.prompt()
				.title('Apply Discount')
				.textContent('How much discount should be applied to the invoice? (£)')
				.ariaLabel('Discount')
				.targetEvent(ev)
				.ok('Apply')
				.cancel('Cancel');

			$mdDialog.show(confirm).then(function (result) {
				if (result !== undefined) {
					if (result > self.invoiceSummary.totalInvoiceValueGross) {
						$mdDialog.show(
							$mdDialog.alert()
								.clickOutsideToClose(true)
								.title('Unable to set discount')
								.textContent('The discount amount exceeds the total invoice value')
								.ariaLabel('Discount')
								.ok('Okay')
								.targetEvent(ev)
						);
					} else if (Number(result) > 0) {
						self.visit.discount_price = -Math.abs(Number(result));
						self.visit.discount_price_vat = TaxHelperSvc.vatFromNet(self.visit.discount_price);
						self.visit.discount_price_gross = TaxHelperSvc.grossFromNet(self.visit.discount_price);
						generateInvoiceSummary();
					} else {
						$mdDialog.show(
							$mdDialog.alert()
							.clickOutsideToClose(true)
							.title('Unable to set discount')
							.textContent('Invalid discount amount')
							.ariaLabel('Discount')
							.ok('Okay')
							.targetEvent(ev)
						);
					}
				}
			});
		}

		function removeDiscount() {
			self.visit.discount_price = self.visit.discount_price_vat = self.visit.discount_price_gross = 0;
			generateInvoiceSummary();
		}

		function generateInvoiceSummary() {
			// empty current invoice summary
			self.invoiceSummary = {
				treatments: []
			};

			var totalInvoiceValue = 0;
			var totalInvoiceValueGross = 0;
			if (self.job.invoice_method === 'upfront' || self.job.invoice_method === 'period') {
				// check for any additional treatments
				// always creates an additional customer invoice
				angular.forEach(self.visit.treatments, function (treatment) {
					if (treatment.treatment.additional_treatment && !treatment.inactive && !treatment.delete) {
						self.invoiceSummary.treatments.push(treatment);
						totalInvoiceValue += parseFloat(treatment.treatment.selling_price_per_treatment_net);
						totalInvoiceValueGross += parseFloat(treatment.treatment.selling_price_per_treatment_gross);
					}
				});
				angular.extend(self.invoiceSummary, {
					// discount stored and calculated as negative number
					totalInvoiceValue: totalInvoiceValue + self.visit.discount_price,
					totalInvoiceValueGross: totalInvoiceValueGross + parseFloat(self.visit.discount_price_gross)
				});
			}
			else if (self.job.invoice_method === 'each_visit') {
				// add all treatments regardless of whether they're additional, these will all get added to the same invoice
				angular.forEach(self.visit.treatments, function (treatment) {
					if (!treatment.inactive && !treatment.delete && (treatment.completed || treatment.completed == null)) {
							// if ((self.visitPreinvoiced && treatment.treatment.additional_treatment) || !self.visitPreinvoiced) {
								self.invoiceSummary.treatments.push(treatment);
								totalInvoiceValue += parseFloat(treatment.treatment.selling_price_per_treatment_net);
								totalInvoiceValueGross += parseFloat(treatment.treatment.selling_price_per_treatment_gross);
							// }
					}
				});
				// Additional costs
				if (self.visit.additional_cost.gross) {
					totalInvoiceValue += parseFloat(self.visit.additional_cost.net);
					totalInvoiceValueGross += parseFloat(self.visit.additional_cost.gross);
				}

				angular.extend(self.invoiceSummary, {
					// discount stored and calculated as negative number
					totalInvoiceValue: totalInvoiceValue + self.visit.discount_price,
					totalInvoiceValueGross: totalInvoiceValueGross + parseFloat(self.visit.discount_price_gross)
				});

				if (self.visitPreinvoiced) {
					if (angular.isObject(self.visit.invoices)) {
						// find the pre-invoiced invoice (we can't use preinvoiced flag reliably yet as still supporting bms1)
						angular.forEach(self.visit.invoices, function (invoice) {
							if (invoice.preinvoiced || (!invoice.is_manual && self.job.invoice_method == 'each_visit')) { // if it isn't manual assume it's pre-invoiced
								self.currentInvoiceTotal = invoice.subtotal_net;
							}
						});
					}

					if (self.currentInvoiceTotal != self.invoiceSummary.totalInvoiceValue) {
						self.invoiceValueVariance = true;
					}
				}
			}

			console.log(self.invoiceSummary);

			self.preinvoicedAmountVariance = (TaxHelperSvc.roundDecimals(self.currentInvoiceTotal, 2) !== TaxHelperSvc.roundDecimals(self.invoiceSummary.totalInvoiceValue, 2) && self.visitPreinvoiced);

		}

		function productsWithoutChemicalRecords() {
			var productsWithoutRecords = [];
			angular.forEach(self.visit.treatments, function (treatment) {
				if (!treatment.inactive && (treatment.completed || treatment.completed == null)) {

					if (angular.isObject(treatment.treatment.products)) {
						angular.forEach(treatment.treatment.products, function (product) {
							if (angular.isObject(product.product_attr)) {
								if (product.product_attr.chemical_app_required && !angular.isObject(product.chemical_record) && !treatment.delete) {
									productsWithoutRecords.push(angular.copy(product));
								}
							}
						});
					}
				}
			});
			return productsWithoutRecords;
		}

		function submit() {
			if ($scope.formValidator.valid()) {
				// Check we have all chemical application records filled out
				var products = productsWithoutChemicalRecords();
				if (products.length > 0) {
					var productName = ''
					angular.forEach(products, function(product) {
						productName += product.product_attr.name + '<br>';
					});

					$mdDialog.show(
						$mdDialog.alert()
							.clickOutsideToClose(true)
							.title('Chemical Records Outstanding')
							.htmlContent('The following products require a chemical application record<br><br>' + productName)
							.ariaLabel('Chemical records')
							.ok('Okay')
					);
				}
				else {
					var visit = angular.copy(self.visit);
					if (angular.isObject(visit.start_time)) {
						visit.start_time = visit.start_time.format('HH:mm');
					}
					if (angular.isObject(visit.end_time)) {
						visit.end_time = visit.end_time.format('HH:mm');
					}
					self.processing = true;
					return TGVisitSvc.close(visit).then(function(response) {
						self.processing = false;
						notify({
							message: 'Visit successfully closed'
						});
						$state.go('main.trugreen.job.closeJobList');
					}, function(errors) {
						console.log(errors);
						self.errors = errors;
					});
				}


			}
			else {
				console.info('not valid');
			}
		}

		function recentPayments(){
			RecentPaymentSvc.showRecentPaymentModal(self.job.customer);
		}

		function rolloverToggled(){
			if(!self.visit.copy){
				self.visit.unconfirmed = false;
			}
		}

		var self = $scope.TGCloseJobCtrl = {
			loading: true,
			processing: false,
			options: {},
			methods: {
				init: init,
				onAdditionalCostNetChanged: onAdditionalCostNetChanged,
				onAdditionalCostGrossChanged: onAdditionalCostGrossChanged,
				treatmentInactivePressed: treatmentInactivePressed,
				editProduct: editProduct,
				editTreatment: editTreatment,
				deleteTreatment: deleteTreatment,
				addTreatment: addTreatment,
				applyInvoiceDiscount: applyInvoiceDiscount,
				removeDiscount: removeDiscount,
				generateInvoiceSummary: generateInvoiceSummary,
				chemicalRecord: chemicalRecord,
				timeUpdated: timeUpdated,
				addCustomerPayment: addCustomerPayment,
				removeCustomerPayment: removeCustomerPayment,
				submit: submit,
				recentPayments :recentPayments,
				rolloverToggled :rolloverToggled,
			}
		};


	});
